// ─────────────────────────────────────────────────────────────
// SetupBanner
// Extracted from App.js.
// ─────────────────────────────────────────────────────────────

import { useState } from "react";
import { C } from "../../lib/colors";
import { SCHEMA_SQL } from "../../lib/schema";

export function SetupBanner({ onDismiss }) {
  const [copied, setCopied] = useState(false);
  const copy = () => { navigator.clipboard?.writeText(SCHEMA_SQL); setCopied(true); setTimeout(() => setCopied(false), 2000); };
  return (
    <div style={{ background: "linear-gradient(135deg, #1a1d2e, #161827)", border: `1px solid ${C.blue}40`, borderRadius: 14, padding: 20, marginBottom: 20 }}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", flexWrap: "wrap", gap: 10 }}>
        <div>
          <div style={{ fontSize: 14, fontWeight: 700, color: C.blue, marginBottom: 6 }}>⚡ Connect Supabase for Live Persistence</div>
          <div style={{ fontSize: 12, color: C.sub, lineHeight: 1.6 }}>
            Running in demo mode with local data. To enable real persistence:<br />
            1. Create a free project at <span style={{ color: C.blue }}>supabase.com</span><br />
            2. Run the SQL schema below in your SQL Editor<br />
            3. Paste your Project URL + Anon Key at the top of this file
          </div>
        </div>
        <button onClick={onDismiss} style={{ background: "none", border: "none", color: C.muted, cursor: "pointer", fontSize: 18 }}>✕</button>
      </div>
      <div style={{ marginTop: 14, display: "flex", gap: 10, flexWrap: "wrap" }}>
        <button onClick={copy} style={{ background: C.blue + "18", border: `1px solid ${C.blue}30`, color: C.blue, borderRadius: 8, padding: "8px 14px", fontSize: 12, cursor: "pointer", fontWeight: 600 }}>
          {copied ? "✓ Copied!" : "📋 Copy Schema SQL"}
        </button>
        <a href="https://supabase.com/dashboard" target="_blank" rel="noreferrer"
          style={{ background: C.green + "18", border: `1px solid ${C.green}30`, color: C.green, borderRadius: 8, padding: "8px 14px", fontSize: 12, textDecoration: "none", fontWeight: 600 }}>
          Open Supabase →
        </a>
      </div>
    </div>
  );
}

// ─────────────────────────────────────────────────────────────
// DASHBOARD
// ─────────────────────────────────────────────────────────────
// ─────────────────────────────────────────────────────────────
// MARKET INTELLIGENCE - ECONOMIC CALENDAR
// ─────────────────────────────────────────────────────────────
